import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { setMappingFile } from '../store/actions/importer';
import { setIgnoredRecordIndex, getFileRecord } from '../store/actions/mapping';
import SendSupportModal from '../send_support_modal';
import {
  getCurrentFile,
  getColumnMappings,
  getRecordsCount,
  getFieldsOptions,
  getIgnoredRecordIndex,
  getIgnoredRecord
} from '../store/selectors';

export function MappingIgnoredData({
  columnMappings,
  currentFile,
  fieldOptions,
  getFileRecord,
  record,
  recordsCount,
  recordIndex,
  setIgnoredRecordIndex
}) {
  const [recordContent, setRecordContent] = useState([]);
  const [showSendSupportModal, setShowSendSupportModal] = useState(false);

  const handleSendSupport = () => {
    setShowSendSupportModal(true);
  };

  const setIndex = (count) => {
    const index = recordIndex + count;
    if (index === recordsCount) {
      setIgnoredRecordIndex(0);
      return;
    }
    if (index < 0) {
      setIgnoredRecordIndex(recordsCount - 1);
      return;
    }
    setIgnoredRecordIndex(index);
  };

  useEffect(() => {
    getFileRecord(true);
  }, [currentFile]);

  useEffect(() => {
    getFileRecord(true);
  }, [recordIndex]);

  useEffect(() => {
    if (!record) return;
    setRecordContent(record.content);
  }, [record]);
  
  const renderColumnMapping = (column) => {
    const columnMapping = column.columnMapping;
    if (column.columnCount === 0) return;

    const option = fieldOptions.find((option) => {
      return option[1] === columnMapping.fieldName;
    });
    if (option) return;

    return (
      <tr className="disable" key={columnMapping.id}>
        <td>{columnMapping.name}</td>
        <td>{record && recordContent[columnMapping.index]}</td>
      </tr>
    );
  };

  return (
    <React.Fragment>
      <div className="mb-4">
        <h3 className="semi-bold mb-4">Ignored Data</h3>
        <p className="mt-4">
          Some of your data has been ignored and will not be imported because the imports
          system did not recognize the data or it could not find a matching Buildout field.
          You can review the ignored fields on the table below.
        </p>
      </div>
      <div className="mapped-data mb-5 table-scroll">
        <table className="table table-bordered thead-inverse js-mapping-table mapping-table show-zero-columns">
          <thead>
            <tr>
              <th className="text-center dark">CSV Field</th>
              <th className="text-center dark">
                <small className="pull-left text-muted last-sample clickable" onClick={()=> setIndex(-1)}>
                  &lt;&lt;
                </small>
                Sample
                <small className="pull-right text-muted next-sample clickable" onClick={()=> setIndex(1)}>
                  &gt;&gt;
                </small>
              </th>
            </tr>
          </thead>
          <tbody className="class_name">
            {columnMappings.map(renderColumnMapping)}
          </tbody>
        </table>
        <p className="larger-text mt-2 mb-2">
          If you don't want to continue with this import due to the ignored data,
          you can send this import request to Buildout's Data Team to take over the import process.
        </p>
        <button className="btn btn-outline-dark btn-sm" type="button" onClick={handleSendSupport}>
          Send to Support
        </button>
      </div>
      <SendSupportModal
        shown={showSendSupportModal}
        onClose={setShowSendSupportModal}
      />
    </React.Fragment>
  );
}

MappingIgnoredData.propTypes = {
  columnMappings: PropTypes.array.isRequired,
  currentFile: PropTypes.object.isRequired,
  fieldOptions: PropTypes.array.isRequired,
  getFileRecord: PropTypes.func.isRequired,
  record: PropTypes.object,
  recordIndex: PropTypes.number.isRequired,
  recordsCount: PropTypes.number.isRequired,
  setIgnoredRecordIndex: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  currentFile: getCurrentFile(state),
  columnMappings: getColumnMappings(state),
  recordIndex: getIgnoredRecordIndex(state),
  recordsCount: getRecordsCount(state),
  record: getIgnoredRecord(state),
  fieldOptions: getFieldsOptions(state)
});

const mapDispatchToProps = {
  setMappingFile,
  setIgnoredRecordIndex,
  getFileRecord
};

export default connect(mapStateToProps, mapDispatchToProps)(MappingIgnoredData);
